// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-card[data-v-e1fbcbdc] {\n  font-size: 14px;\n  width: 100%;\n  padding: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  font-weight: bold;\n}\n.button-card[data-v-e1fbcbdc]:hover {\n  background-color: #F7F7F7;\n}\n.button-card-icon[data-v-e1fbcbdc] {\n  padding-right: 20px;\n  color: #4CAF50;\n}\n", ""]);
// Exports
module.exports = exports;
